import React, { createContext, useContext, useState } from 'react';

// Create Context
const GlobalContext = createContext();

// Provider Component
export const GlobalProvider = ({ children }) => {
  const [state, setState] = useState({
    uploadedImage: null, // Store image URL or file
    photoManagement: null,
  });

  // Update state function
  const updateState = (newState) => {
    setState((prev) => ({ ...prev, ...newState }));
  };

  return (
    <GlobalContext.Provider value={{ state, updateState }}>
      {children}
    </GlobalContext.Provider>
  );
};

// Custom hook to access global state
export const useGlobalState = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobalState must be used within a GlobalProvider');
  }
  return context;
};